export const Exclamation = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6C12.6628 6 13.2 6.53726 13.2 7.2V13.2C13.2 13.8628 12.6628 14.4 12 14.4C11.3372 14.4 10.8 13.8628 10.8 13.2V7.2C10.8 6.53726 11.3372 6 12 6Z"
        fill="#5E6BA2"
      />
      <path
        d="M12 18C12.6628 18 13.2 17.4628 13.2 16.8C13.2 16.1372 12.6628 15.6 12 15.6C11.3372 15.6 10.8 16.1372 10.8 16.8C10.8 17.4628 11.3372 18 12 18Z"
        fill="#5E6BA2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM2.4 12C2.4 6.69806 6.69806 2.4 12 2.4C17.302 2.4 21.6 6.69806 21.6 12C21.6 17.302 17.302 21.6 12 21.6C6.69806 21.6 2.4 17.302 2.4 12Z"
        fill="#5E6BA2"
      />
    </svg>
  );
};
